export const CREATE_JOB  = 'CREATE_JOB';
export const GET_JOB  = 'GET_JOB';
export const JOB_REQUEST  = 'JOB_REQUEST';
export const DELETE_JOB  = 'DELETE_JOB';
export const UPDATE_JOB  = 'UPDATE_JOB';
export const JOB_REQUEST_FAILURE  = 'JOB_REQUEST_FAILURE';